import styled from 'styled-components'

export const RowsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
`
